<!-- LOAD ACTIVITIES MODAL -->
<template>
  <b-modal
    id="load-activities-modal"
    size="xl"
    :title="'Load [' + loadCount + '] Activities'"
    scrollable
  >
    <p>
      <b-row>
        <b-col class="scrollable" cols="4">
          <div id="activities-list-container">
            <b-table-simple
              id="activities-list"
              sticky-header
              stick
              class="table table-sm table-bordered"
            >
              <b-thead>
                <b-tr>
                  <b-th class="checkSelect" />
                  <b-th>Activity</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>[Select All]</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>ARR_CONS</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>ARR_SHIP</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>Arrival Date Changed</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>ARV_CONS</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>Carrier Changed</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>COMPLETE</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>Depart Date Changed</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>DEST EARLIEST DATE</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>DEST LATEST DATE</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>ETA CONS</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="checkSelect" />
                  <b-td>Freight Update</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-col>
        <b-col cols="8">
          <div id="activities-details-table-container" class="scrollable">
            <b-table-simple
              id="activities-details-table"
              sticky-header
              class="table table-sm table-bordered"
            >
              <b-thead>
                <b-tr>
                  <b-th>Date</b-th>
                  <b-th>User</b-th>
                  <b-th>Activity</b-th>
                  <b-th>Notes</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr class="text-nowrap">
                  <b-td>04/19/2017 09:27</b-td>
                  <b-td>COLUMBUS17</b-td>
                  <b-td>ETA CONS</b-td>
                  <b-td>null -> 2017-04-24 00:00:00</b-td>
                </b-tr>
                <b-tr class="text-nowrap">
                  <b-td>04/19/2017 09:27</b-td>
                  <b-td>COLUMBUS17</b-td>
                  <b-td>Depart Date Changed</b-td>
                  <b-td>LUL[1167660]: 2049 Amet Venenatis Etiam</b-td>
                </b-tr>
                <b-tr class="text-nowrap">
                  <b-td>04/19/2017 09:27</b-td>
                  <b-td>COLUMBUS17</b-td>
                  <b-td>Arrival Date Changed</b-td>
                  <b-td>LUL[1167660]: 2049 Amet Venenatis Etiam</b-td>
                </b-tr>
                <b-tr class="text-nowrap">
                  <b-td>04/19/2017 09:27</b-td>
                  <b-td>COLUMBUS17</b-td>
                  <b-td>Freight Update</b-td>
                  <b-td>LUL[1167660]: 2049 Amet Venenatis Etiam</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
          <div class="text-right mt-2">
            <b-button href="" variant="secondary">
              Print
            </b-button>
          </div>
        </b-col>
      </b-row>
    </p>
    <template v-slot:modal-footer class="justify-content-center">
      <b-button
        variant="primary"
        data-dismiss="modal"
        @click="$bvModal.hide('load-activities-modal')"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>
<!-- END LOAD ACTIVITIES MODAL -->

<script>
import * as modals from "@/lib/modals";

export default {
  name: modals.loadActivitiesModal,
  props: {
    loadCount: {
      default: 0,
      type: Number
    }
  }
};
</script>
